import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { ShieldCheck, Droplets, BarChart3, TrendingUp } from 'lucide-react';

export default function PlasticCreditsSection() {
  const { t } = useLanguage();
  const ref = useScrollReveal();

  const cards = [
    { icon: ShieldCheck, title: t('credits.card1_title'), desc: t('credits.card1_desc') },
    { icon: Droplets, title: t('credits.card2_title'), desc: t('credits.card2_desc') },
    { icon: BarChart3, title: t('credits.card3_title'), desc: t('credits.card3_desc') },
    { icon: TrendingUp, title: t('credits.card4_title'), desc: t('credits.card4_desc') },
  ];

  return (
    <section id="credits" data-testid="credits-section" className="py-24 md:py-32 relative">
      <div className="absolute inset-0 bg-[#0B1E2E]" />

      <div ref={ref} className="reveal relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-sm uppercase tracking-widest text-[#42D2D9] font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
          {t('credits.caption')}
        </p>
        <div className="section-line mb-8" />

        <div className="max-w-3xl mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-white mb-6" style={{ fontFamily: 'Outfit, sans-serif' }}>
            {t('credits.title')}
          </h2>
          <p className="text-base md:text-lg leading-relaxed text-slate-300">
            {t('credits.description')}
          </p>
        </div>

        {/* Bento Grid */}
        <div className="bento-grid">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <div
                key={i}
                data-testid={`credit-card-${i}`}
                className={`glass-card p-8 rounded-lg ${i === 0 ? 'md:col-span-2 lg:col-span-1' : ''}`}
              >
                <div className="w-12 h-12 rounded-lg bg-[#42D2D9]/10 flex items-center justify-center mb-6">
                  <Icon className="w-6 h-6 text-[#42D2D9]" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {card.title}
                </h3>
                <p className="text-sm text-slate-400 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
